(function () {
    var triggerHighlight = document.querySelectorAll('[trigger-highlight]'),
        triggerRedirect = document.querySelector('[trigger-redirect]'),
        selectIndustries = document.querySelector('#slt-industries'),
        selectSolutions = document.querySelector('#slt-solutions');



    if (triggerHighlight) {
        for (var i = 0, max = triggerHighlight.length; i < max; i++) {
            triggerHighlight[i].addEventListener('change', function () {
                var el = this;
                highlight(el);
            });
        }
    }

    // Check if both select are value 0. IF yes, redirect to hardcoded page.
    if (selectIndustries && selectSolutions && triggerRedirect ) {

        triggerRedirect.addEventListener('submit', function(e){

            var lang = document.querySelector('html').getAttribute('lang');

            if ( selectIndustries.selectedIndex == 0 && selectSolutions.selectedIndex == 0 ) {
                e.preventDefault();

                if ( lang ) {
                    if ( lang == 'fr') {
                        window.location = 'https://www.createch.ca/fr/solutions';
                    } else if ( lang == 'en') {
                        window.location = 'https://www.createch.ca/solutions';
                    }
                }
            }
        });
    }

    function highlight(el) {

        if ( el.selectedIndex == 0) {
            el.classList.add('is-active');
        }

        for (var i = 0, max = triggerHighlight.length; i < max; i++) {

            triggerHighlight[i].classList.add('is-active');

            if (triggerHighlight[i].selectedIndex !== 0) {
                triggerHighlight[i].classList.remove('is-active');
            } else {
                triggerHighlight[i].classList.add('is-active');
            }
        }
    }
})();
